import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>

      <body className='hidden-bar-wrapper'>
        <div className='page-wraper'>
          <footer className="main-footer" style={{ background: "url(assets/images/background/pattern-8.png)", background: "linear-gradient(45deg,#053633,#0f903f)" }}>

            <span className="footer-vector_one">
              <img src="assets/images/resource/footer-vector-1.png" alt />

            </span>
            <span className="footer-vector_two">
              <img src="assets/images/resource/footer-vector-2.png" alt />
            </span>
            <div className="auto-container">
              {/*Widgets Section*/}
              <div className="main-footer_widgets" >
                <div className="row clearfix" style={{ marginTop: "-130px" }}>
                  {/*big column*/}
                  <div className="big-column col-lg-6 col-md-12 col-sm-12" >
                    <div className="row clearfix">
                      {/*Footer Column*/}
                      <div className="main-footer_column col-lg-7 col-md-6 col-sm-12">
                        <div className="footer-widget logo-widget">
                          <div className="main-footer_logo">
                            <Link to="/"><img src="assets/img/logo_2.png" alt /></Link>
                          </div>
                          <div className="main-footer_text">Satna Swastik Hospital established in 2024 comes from a long legacy of superior healthcare provided by the Satna Swastik Hospital.</div>
                          {/* Social Box */}
                          <ul className="footer-social_box" style={{ marginLeft: "130px" }}>
                            <li><a href="https://www.facebook.com/satnaswastikhospital?rdid=srVwFThyEaQINAn5&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1AmFAs294K%2F#" target="_blank" className="fa-brands fa-facebook-f fa-fw" /></li>
                            <li><a href="https://www.instagram.com/satnaswastikhospital/" target="_blank" className="fa-brands fa-instagram fa-fw" /></li>
                            <li><a href="https://youtube.com/@swastikhospital-n3b?si=eJE49e2e08PFU_yT" target="_blank" className="fa-brands fa-youtube fa-fw" /></li>
                          </ul>
                        </div>
                      </div>
                      {/*Footer Column*/}
                      <div className="main-footer_column col-lg-5 col-md-6 col-sm-12">
                        <div className="footer-widget links-widget">
                          <h4 className="main-footer_title">Service</h4>
                          <ul className="main-footer_list">
                            <li><Link to="/about-us">About Us</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/our-doctor">Our Doctor</Link></li>
                            <li><Link to="/gallery">Gallery</Link></li>
                            <li><Link to="/appointment">Book Appointment</Link></li>
                            <li><Link to="/contact-us">Contact Us</Link></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*big column*/}
                  <div className="big-column col-lg-6 col-md-12 col-sm-12">
                    <div className="row clearfix">
                      {/*Footer Column*/}
                      <div className="main-footer_column col-lg-6 col-md-6 col-sm-12">
                        <div className="footer-widget news-widget">
                          <h4 className="main-footer_title">Recent Posts</h4>
                          {/*News Widget Block*/}
                          <div className="news-widget-block">
                            <div className="news-widget_image">
                              <img src="assets/img/Doctor Symbol.png" alt />
                            </div>
                            {/* <div className="news-widget_post-date">DECEMBER 12, 2022</div> */}
                            <h6 className="news-widget_title"><a style={{ color: "white" }} to="blog-detail.html">24/7 General Enquiry</a></h6>
                            <h6 className="news-widget_title"><a style={{ color: "white" }} to="blog-detail.html">100% Expert Doctors</a></h6>
                            <h6 className="news-widget_title"><a style={{ color: "white" }} to="blog-detail.html">Only Qualified Doctors</a></h6>
                            {/* <a href='tel: +91 7672326319' style={{ color: "white" }} > +91 7672326319</a><br />
                            <a href='tel: +91 7509182172' style={{ color: "white" }} > +91 7509182172</a> */}
                          </div>
                          {/*News Widget Block*/}
                          <div className="news-widget-block">
                            <div className="news-widget_image">
                              <img src="assets/img/General Enquiry.png" alt />
                            </div>
                            {/* <div className="news-widget_post-date">DECEMBER 12, 2022</div> */}
                            <h6 className="news-widget_title"><a style={{ color: "white" }} to="blog-detail.html">Emergency Helpline</a></h6>
                            {/* <a href='tel: +91 7672326319' style={{ color: "white" }} > +91 7672326319</a><br />
                            <a href='tel: +91 7509182172' style={{ color: "white" }} > +91 7509182172</a> */}
                          </div>
                        </div>
                      </div>
                      {/*Footer Column*/}
                      <div className="main-footer_column col-lg-6 col-md-6 col-sm-12">
                        <div className="footer-widget contact-widget">
                          <h4 className="main-footer_title">Contact Info</h4>
                          <ul className="main-footer_contact-list">
                            <li><span className="icon fa-solid fa-location fa-fw" /> <a href='https://share.google/Ekv0nUxkNaGImU8TX' target="_blank">सतना स्वास्तिक हॉस्पिटल पन्नीलाल चौक, सतना (म.प्र.)</a></li>
                            <li><span className="icon fa-solid fa-phone fa-fw" />
                              <a href='tel: +91 7672326319' > +91 7672326319</a>
                              <br />
                              <a href='tel: +91 7509182172' > +91 7509182172</a>
                            </li>
                            <li><span className="icon fa-solid fa-envelope fa-fw" /> <a href="mailto:satnaswastikhospital@gmail.com">satnaswastikhospital@gmail.com</a></li>
                            <li><span className="icon fa-solid fa-clock fa-fw" />24 Hours <br /> 24/7 Emergency Services</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="main-footer_bottom">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <div className="footer_copyright">Copyright 2025 merit All Rights Reserved</div>
                  <div className="footer-scroll_top scroll-to-target" data-target="html"><span className="fa fa-arrow-up" /></div>
                </div>
              </div> */}
            </div>
          </footer>



        </div>
      </body>
      <WhatsappIcon />



    </>
  )
}

export default Footer